/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:3cb3cf61-2158-40fe-8c28-37f8d8686621",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_UZOm40iIi",
    "aws_user_pools_web_client_id": "v8123b2qvj5b2q1aainvptc98",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_appsync_graphqlEndpoint": "https://e36dneaznjdnnpk6m6ptljmyya.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-yuvrrxj4jrc4nh6aihndt7bfo4",
    "aws_cloud_logic_custom": [
        {
            "name": "jojooMailerApi",
            "endpoint": "https://ncxsgd7yl8.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_login_mechanisms": [
        "PREFERRED_USERNAME"
    ]
};


export default awsmobile;
